<!-- 问卷列表-查看详情 -->
<template>
  <div class="main">
    <div class="header-section">
      <div class="header-content">
        <h1>{{ questionnaireName }} - 填写记录</h1>
        <p>{{ questionnaireIntroduce }}</p>
      </div>
      <div class="header-buttons">
        <el-button type="success" icon="el-icon-download" @click="exportData">导出数据</el-button>
        <el-button type="danger" icon="el-icon-back" @click="goBack">返回列表</el-button>
      </div>
    </div>

    <div class="s_wrapper">
      <el-input class="s_input" v-model="nickName" suffix-icon="el-icon-search" placeholder="搜索用户名称" clearable
        @change="onSearch"></el-input>
      <el-input class="s_input" v-model="phoneNum" suffix-icon="el-icon-search" placeholder="搜索用户手机" clearable
        @change="onSearch"></el-input>
    </div>
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="nickName" label="用户名称"></el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="phoneNum" label="用户手机"></el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="createdTime" label="提交时间"></el-table-column>
        <el-table-column show-overflow-tooltip label="操作" header-align="center" align="center" fixed="right"
          min-width="200">
          <template slot-scope="scope">
            <el-button type="primary" plain @click="handleCheck(scope.row)">查看答卷</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"
      :before-close="handleClose"></el-pagination>

    <el-drawer title="查看答卷" :visible.sync="drawerVisible" direction="rtl">
      <div class="answer-info">
        <!-- 用户基本信息 -->
        <div class="user-basic">
          <p class="user-name">{{ currentAnswer.nickName }}</p>
          <p class="user-meta">{{ currentAnswer.phoneNum }} · {{ currentAnswer.createdTime }}</p>
        </div>
        <hr class="custom-hr">
        <!-- 答卷问题列表 -->
        <div class="question-item" v-for="(item, index) in currentAnswer.answerVoList" :key="index">
          <p class="question-title"><span class="question-index">{{ index + 1 }}.</span> {{ item.questionName }}</p>
          <p class="question-answer">{{ item.answer }}</p>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nickName: "",
      phoneNum: "",
      questionnaireId: null,
      questionnaireName: null,
      questionnaireIntroduce: null,
      datetime: [], //时间区间
      tableData: [], //表格数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）

      drawerVisible: false, // 控制抽屉是否显示
      currentAnswer: {}, // 存储当前要查看的答卷数据
    }
  },
  created() {
    this.questionnaireId = this.$route.query.questionnaireId
    this.questionnaireName = this.$route.query.questionnaireName
    this.questionnaireIntroduce = this.$route.query.questionnaireIntroduce
    this.selectQuestionnaireUser()
  },

  methods: {
    // 导出数据方法
    exportData() {
      this.loading = true
      let params = {
        nickName: this.nickName || null,
        phoneNum: this.phoneNum || null,
        questionnaireId: this.questionnaireId || null,
      }

      this.$axios
        .post(this.$api.exportQuestionnaireUser, params)
        .then(res => {
          if (res.code == 100) {
            this.$message.success(res.desc)
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 返回列表
    goBack() {
      this.$router.push({ path: "/question/questionList" });
    },
    // 获取列表
    selectQuestionnaireUser() {
      this.loading = true
      let params = {
        nickName: this.nickName || null,
        phoneNum: this.phoneNum || null,
        questionnaireId: this.questionnaireId || null,
        page: this.currentPage,
        pageSize: this.pageSize,
      }

      this.$axios
        .get(this.$api.selectQuestionnaireUser, { params })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalItemsCount = res.result.totalCount
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 查看答卷
    handleCheck(row) {
      let params = {
        questionnaireId: this.questionnaireId,
        userId: row.userId,
      }
      this.$axios
        .get(this.$api.selectUserAnswer, { params })
        .then(res => {
          if (res.code == 100) {
            // 保存当前答卷数据
            this.currentAnswer = res.result
            // 打开抽屉
            this.drawerVisible = true
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 关闭抽屉
    handleClose() {
      this.drawerVisible = false;
    },
    onSearch() {
      this.clearData()
      this.selectQuestionnaireUser()
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.selectQuestionnaireUser()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.selectQuestionnaireUser()
    },
  },
}
</script>

<style scoped lang="scss">
.main {
  ::v-deep .el-drawer {


    .el-drawer__header {
      margin-bottom: 16px;

      span {
        font-size: 20px;
        font-weight: bold;
        color: #333;
      }

      .el-drawer__close-btn {
        top: 12px;
      }
    }
  }

  .answer-info {
    padding: 20px;

    .user-basic {
      .user-name {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 8px;
      }

      .user-meta {
        font-size: 14px;
        color: #666;
        margin-bottom: 16px;
      }
    }

    .custom-hr {
      border: none;
      height: 1px;
      background-color: #eee;
      margin: 0 0 16px 0;
    }

    .question-item {
      margin-bottom: 16px;
      padding-bottom: 16px;
      border-bottom: 1px solid #eee;


      &:last-child {
        border-bottom: none;
      }

      .question-title {
        font-size: 16px;
        color: #333;
        margin-bottom: 6px;

        .question-index {
          margin-right: 4px;
        }
      }

      .question-answer {
        font-size: 18px;
        color: black;
        padding-left: 20px;
      }
    }
  }


  .header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    background-color: #f9fafc;
    border-radius: 6px;
    margin-bottom: 20px;

    .header-content {
      h1 {
        margin-bottom: 10px;
      }

      p {
        font-size: 14px;
        color: #606266;
        line-height: 1.5;
        // width: 770px;
        width: 900px;
      }
    }

    .header-buttons {
      display: flex;
      gap: 12px;
    }
  }
}
</style>
